import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import DesktopNav from "@/components/navbar/DesktopNav";
import MobileNav from "@/components/navbar/MobileNav";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const closeMobile = () => setIsOpen(false);

  return (
    <nav
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 glass border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <Link to="/" data-testid="nav-logo" className="flex items-center" />
          <DesktopNav />
          <button
            data-testid="mobile-menu-button"
            className="lg:hidden p-2 text-gray-300 hover:text-white"
            onClick={() => setIsOpen((v) => !v)}
            aria-label="Toggle navigation"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      <MobileNav open={isOpen} onClose={closeMobile} />
    </nav>
  );
}
